export { default } from './StylishLink';
export type { StylishLinkVariant } from './StylishLink';
